import DataWarnings from "./DataWarnings";

export default DataWarnings;
